import getStore from '../store/store';
import SuggestedRepliesOptionState from '../store/schema/SuggestedRepliesOptionState';
import { mutator } from 'satcheljs';
import { selectAction } from '../actions/suggestedRepliesOptionActions';

export default mutator(selectAction, actionMessage => {
    // Update store value based on user selection.
    // We will either discard this value or save it on the backend,
    // depending on user's actions.
    const optionState: SuggestedRepliesOptionState = getStore();
    optionState.isEnabled = actionMessage.isEnabled;
});
